import { CustomKeyAttributes } from '@loyalty/shared-common/profile-api-client';
import { Fields } from '@react-awesome-query-builder/core';
import { BaseConfigSettings } from '../fields';
import { profileFields } from './profile-fields';
import { referralExcludedOperators } from '../settings';

export function qualifioLoyaltyProfileCreation(
  settings: BaseConfigSettings,
  customKeys?: CustomKeyAttributes[],
): Fields {
  const { t } = settings;
  return {
    event: {
      label: t('rule.criteria.event'),
      type: '!group',
      subfields: {
        referralCode: {
          label: t('rule.criteria.ecommerce.referral.used'),
          type: 'text',
          valueSources: ['value'],
          excludeOperators: referralExcludedOperators,
        },
        timestamp: {
          label: t('rule.criteria.date'),
          type: 'date',
          preferWidgets: ['date'],
        },
      },
    },
    profile: {
      label: t('rule.criteria.profile'),
      type: '!group',
      subfields: profileFields(settings, customKeys),
    },
  };
}
